import SuccessBizum from "@/views/public/success/bizum/SuccessBizum.vue";

export default {
  path: "/success-bizum",
  name: "successBizum",
  component: SuccessBizum
};
